const c = new Intl.Collator();
function r(n, e) {
  if (e.length === 0)
    return !0;
  n = n.normalize("NFC"), e = e.normalize("NFC");
  let l = 0;
  const o = e.length;
  for (; l + o <= n.length; l++) {
    const t = n.slice(l, l + o);
    if (c.compare(e, t) === 0)
      return !0;
  }
  return !1;
}
export {
  r as strContains
};
//# sourceMappingURL=helpers.mjs.map
